import { render } from "./CustomOptionComponent.vue?vue&type=template&id=8418e0b0&ts=true"
import script from "./CustomOptionComponent.vue?vue&type=script&lang=ts"
export * from "./CustomOptionComponent.vue?vue&type=script&lang=ts"

import "./CustomOptionComponent.vue?vue&type=style&index=0&id=8418e0b0&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__